if (!customElements.get("th-product-card")) {
  class ThProductCard extends HTMLElement {
    constructor() {
      super();

      this.swatchesSelector = "[data-variant-swatch]";
      this.swatchImgSelector = "[data-swatch-img]";
      this.imageContainerSelector = ".product-card__media";
      this.priceWrapperSelector = "[data-product-price ]";
      this.cardLinkSelector = ".product-card__link";
    }

    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }

    attachListeners() {
      this.querySelectorAll(this.swatchesSelector).forEach(
        (swatch) => {
          swatch.addEventListener(
            "click",
            this.handleSwatchChange.bind(this, swatch)
          );
        }
      );
    }

    handleSwatchChange(swatch, event) {
      event.preventDefault();
      const variantId = swatch.dataset.variantId;
      const imageContainer = this.querySelector(this.imageContainerSelector);
      if (!variantId || !imageContainer) {return}
      const activeImgs = this.querySelectorAll(`[data-swatch-img="${variantId}"]`);
      const swatches = this.querySelectorAll(this.swatchesSelector);
      const swatchImgs = this.querySelectorAll(this.swatchImgSelector);
      //Maintain height of image container to avoid jitter
      const imageContainerHeight = imageContainer.offsetHeight;
      imageContainer.style.minHeight = `${imageContainerHeight}px`;
      //remove active classes
      swatches.forEach(el => {
        el.classList.remove('active');
      });
      swatchImgs.forEach(el => {
        el.classList.remove('active');
      });
      //add active classes/styles
      swatch.classList.add('active');
      activeImgs.forEach(img => {
        img.classList.add('active');
        img.style.opacity = 0;
        for (let i = 0; i < 1.1; i = i + 0.1) {           
          setTimeout(function(){img.style.opacity = i;},50)                       
        }
      });
      setTimeout(() => {
        imageContainer.style.minHeight = null;
      }, 500);
      //Change price 
      this.updatePrice(swatch);
      //Update link
      const variantLink = swatch.dataset.variantLink;
      const cardLink = this.querySelector(this.cardLinkSelector);
      if (variantLink && cardLink) {
        cardLink.href = variantLink;
      }
    }

    updatePrice(swatch) {
      const variantPrice = swatch.dataset.variantPrice;
      const variantComparePrice = swatch.dataset.variantComparePrice;
      const priceContainer = this.querySelector(this.priceWrapperSelector);
      if (priceContainer) {
        const comparePriceElm = priceContainer.querySelector("[data-compare-price]");
        const exactPriceElm = priceContainer.querySelector("[data-exact-price]");
        if (comparePriceElm && exactPriceElm && variantPrice && variantComparePrice) {
          comparePriceElm.innerText = Shopify.formatMoney(variantComparePrice, "${{amount_no_decimals}}");
          exactPriceElm.innerText = Shopify.formatMoney(variantPrice, "${{amount_no_decimals}}");
        } else if (variantPrice) {
          priceContainer.innerText = Shopify.formatMoney(variantPrice, "${{amount_no_decimals}}");
        }
      }
    }
  }

  customElements.define("th-product-card", ThProductCard);
}